import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { WalletFundingPanel } from "@/components/WalletFundingPanel";
import { WalletMovements } from "@/components/WalletMovements";

const TABS = [["movimenti", "Storico transazioni"], ["ricariche", "Storico ricariche"], ["auto", "Carta, IBAN e ricarica automatica"], ["provvigioni", "Provvigioni"]];

export default function WalletHistory() {
  const [params, setParams] = useSearchParams();
  const [version, setVersion] = useState(0);
  const tab = TABS.some(([k]) => k === params.get("tab")) ? params.get("tab") : "movimenti";
  const bump = () => setVersion((v) => v + 1);
  return (
    <div className="space-y-6" data-testid="wallet-history-page">
      <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Gestione</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Storico wallet</h1>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })} className="space-y-4">
        <TabsList className="flex-wrap h-auto" data-testid="wallet-tabs">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`wallet-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="movimenti"><WalletMovements version={version} /></TabsContent>
        <TabsContent value="ricariche"><WalletFundingPanel onBalanceChange={bump} view="history" /></TabsContent>
        <TabsContent value="auto"><WalletFundingPanel onBalanceChange={bump} view="auto" /></TabsContent>
        <TabsContent value="provvigioni"><WalletFundingPanel onBalanceChange={bump} view="earnings" /></TabsContent>
      </Tabs>
    </div>
  );
}
